@for (row of rows(); track rowIndex; let rowIndex = $index) {
  <tr role="row">
    <!-- Typically used for week numbers -->
    @if (rowLabels()) {
      <td class="si-calendar-row-label" [attr.data-row]="rowIndex">
        <div [class]="rowLabelCssClasses()">{{ rowLabels()?.at(rowIndex) ?? '' }}</div>
      </td>
    }
    @for (col of row; track colIndex; let colIndex = $index) {
      <td
        role="gridcell"
        class="si-calendar-cell"
        [attr.data-row]="rowIndex"
        [attr.data-col]="colIndex"
        [class]="cellRangeClasses()[rowIndex][colIndex]"
      >
        <button
          siCalendarDateCell
          type="button"
          [cell]="col"
          [compareAdapter]="compareAdapter()"
          [attr.cdkFocusInitial]="isActive(col) ? '' : null"
          [class]="cellCss(col)"
          [class.selected]="selection().isSelected(col, startDate(), endDate())"
          [class.text-secondary]="
            col.isPreview &&
            !col.disabled &&
            !selection().isRangeSelected(col, startDate()) &&
            !selection().isRangeSelected(col, endDate()) &&
            !selection().inRange(col, startDate(), endDate())
          "
          [tabindex]="isActive(col) ? '0' : '-1'"
          (mouseover)="emitActiveHover(col)"
          (click)="emitSelectCell(col)"
          (focus)="emitActiveDateChange(col)"
        >
          {{ col.displayValue }}
        </button>
      </td>
    }
  </tr>
}
